// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormRow_tr__H4wLO {
  height: 85px;
  position: relative;
}
.FormRow_tdData__pPGnI {
  border-top: 1px solid #e1e1e1;
  text-align: center;
  padding: 0 8px;
  max-width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.FormRow_tdField__CrCJd {
  border-top: 1px solid #e1e1e1;
  /* text-align: center; */
  padding-inline: 20px;
  padding-bottom: 18px;
  padding-top: 5px;
  max-width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* overflow: hidden; */
}
.FormRow_actionsContainer__qUpYw {
  border-top: 1px solid #e1e1e1;
  padding-inline-end: 10px;
}
.FormRow_actionIcon__l-NN0,
.FormRow_imgIcon__rv2Ql {
  cursor: pointer;
}

.FormRow_imgUploadContainer__woW7E {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 10px;
}
.FormRow_iconLabel__FRV5J {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.FormRow_fileInput__XShiv {
  display: none;
}
.FormRow_spinnerContainer__TJtqM {
  width: 26px;
  height: 26px;
  margin-left: 3px;
}
.FormRow_spinnerContainer__TJtqM span {
  width: 26px !important;
  height: 26px !important;
}
@media all and (max-width: 900px) {
  .FormRow_tdField__CrCJd {
    padding-inline: 15px;
  }
}
@media all and (max-width: 800px) {
  .FormRow_tdField__CrCJd {
    padding-inline: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MLM/FormNetworkMarketer/FormRow.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".tr {\r\n  height: 85px;\r\n  position: relative;\r\n}\r\n.tdData {\r\n  border-top: 1px solid #e1e1e1;\r\n  text-align: center;\r\n  padding: 0 8px;\r\n  max-width: 220px;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n.tdField {\r\n  border-top: 1px solid #e1e1e1;\r\n  /* text-align: center; */\r\n  padding-inline: 20px;\r\n  padding-bottom: 18px;\r\n  padding-top: 5px;\r\n  max-width: 220px;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  /* overflow: hidden; */\r\n}\r\n.actionsContainer {\r\n  border-top: 1px solid #e1e1e1;\r\n  padding-inline-end: 10px;\r\n}\r\n.actionIcon,\r\n.imgIcon {\r\n  cursor: pointer;\r\n}\r\n\r\n.imgUploadContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  padding-top: 10px;\r\n}\r\n.iconLabel {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n.fileInput {\r\n  display: none;\r\n}\r\n.spinnerContainer {\r\n  width: 26px;\r\n  height: 26px;\r\n  margin-left: 3px;\r\n}\r\n.spinnerContainer span {\r\n  width: 26px !important;\r\n  height: 26px !important;\r\n}\r\n@media all and (max-width: 900px) {\r\n  .tdField {\r\n    padding-inline: 15px;\r\n  }\r\n}\r\n@media all and (max-width: 800px) {\r\n  .tdField {\r\n    padding-inline: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tr": `FormRow_tr__H4wLO`,
	"tdData": `FormRow_tdData__pPGnI`,
	"tdField": `FormRow_tdField__CrCJd`,
	"actionsContainer": `FormRow_actionsContainer__qUpYw`,
	"actionIcon": `FormRow_actionIcon__l-NN0`,
	"imgIcon": `FormRow_imgIcon__rv2Ql`,
	"imgUploadContainer": `FormRow_imgUploadContainer__woW7E`,
	"iconLabel": `FormRow_iconLabel__FRV5J`,
	"fileInput": `FormRow_fileInput__XShiv`,
	"spinnerContainer": `FormRow_spinnerContainer__TJtqM`
};
export default ___CSS_LOADER_EXPORT___;
